<template>
  <div id="trial-to-do-list">
    <div class="trial-list-header">
      <h1>{{ remaining_days }}</h1>
      <h3>Days Left in Your Free 30-Day Trial</h3>
      <img
        v-if="remaining_days > 22"
        src="/images/Trial_Start.png"
        alt="DataCast"
        class="trial-slider"
      />
      <img
        v-else-if="remaining_days > 14 && remaining_days < 23"
        src="/images/Trial_7days.png"
        alt="Trends Report"
        class="trial-slider"
      />
      <img
        v-else-if="remaining_days > 7 && remaining_days < 15"
        src="/images/Trial_15days.png"
        alt="Trends Report"
        class="trial-slider"
      />
      <img
        v-else-if="remaining_days > 0 && remaining_days < 8"
        src="/images/Trial_23days.png"
        alt="Trends Report"
        class="trial-slider"
      />
      <img
        v-else-if="remaining_days < 1"
        src="/images/Trial_END.png"
        alt="Trends Report"
        class="trial-slider"
      />
    </div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div
            class="col-large-6"
            v-bind:class="
              bookWalkthroughIsHidden
                ? 'd-none'
                : '' || book_walkthrough
                  ? 'd-none'
                  : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                bookWalkthroughIsHidden
                  ? 'tl-complete'
                  : '' || book_walkthrough
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Book a Walkthrough</label>
              <p>
                Schedule a walkthrough with one of our Account Executives to
                explore all the features and capabilities of your subscription.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  bookWalkthroughIsHidden
                    ? 'tl-button-complete'
                    : '' || book_walkthrough
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a class="button-blue" v-on:click="bookWalkthrough">Book Now</a>
              </div>
              <div
                class="tl-hidden"
                v-bind:class="
                  bookWalkthroughIsHidden
                    ? 'tl-complete'
                    : '' || book_walkthrough
                      ? 'tl-complete'
                      : ''
                "
              >
                <p
                  v-bind:class="
                    bookWalkthroughIsHidden
                      ? 'tl-completed'
                      : '' || book_walkthrough
                        ? 'tl-completed'
                        : ''
                  "
                >
                  You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6"
            v-bind:class="
              reviewMethodologyIsHidden
                ? 'd-none'
                : '' || review_methodology
                  ? 'd-none'
                  : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                reviewMethodologyIsHidden
                  ? 'tl-complete'
                  : '' || review_methodology
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Review Methodology</label>
              <p>
                Learn more about Rates-of-Change, leading indicator analysis,
                and more, by visiting our methodology page.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  reviewMethodologyIsHidden
                    ? 'tl-button-complete'
                    : '' || review_methodology
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a class="button-blue" v-on:click="reviewMethodology">
                  Learn More
                </a>
              </div>
              <div
                class="tl-hidden"
                v-bind:class="
                  reviewMethodologyIsHidden
                    ? 'tl-complete'
                    : '' || review_methodology
                      ? 'tl-complete'
                      : ''
                "
              >
                <p
                  v-bind:class="
                    reviewMethodologyIsHidden
                      ? 'tl-completed'
                      : '' || review_methodology
                        ? 'tl-completed'
                        : ''
                  "
                >
                  You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6"
            v-bind:class="
              scheduleTechCheckIsHidden
                ? 'd-none'
                : '' || schedule_tech_check
                  ? 'd-none'
                  : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                scheduleTechCheckIsHidden
                  ? 'tl-complete'
                  : '' || schedule_tech_check
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Schedule a Tech Check</label>
              <p>
                Meet with our customer care team to check that everything is
                running smoothly with your subscription.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  scheduleTechCheckIsHidden
                    ? 'tl-button-complete'
                    : '' || schedule_tech_check
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a class="button-blue" v-on:click="scheduleTechCheck">
                  Book Now
                </a>
              </div>
              <div
                class="tl-hidden"
                v-bind:class="
                  scheduleTechCheckIsHidden
                    ? 'tl-complete'
                    : '' || schedule_tech_check
                      ? 'tl-complete'
                      : ''
                "
              >
                <p
                  v-bind:class="
                    scheduleTechCheckIsHidden
                      ? 'tl-completed'
                      : '' || schedule_tech_check
                        ? 'tl-completed'
                        : ''
                  "
                >
                  You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6"
            v-bind:class="
              uploadDataIsHidden ? 'd-none' : '' || upload_data ? 'd-none' : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                uploadDataIsHidden
                  ? 'tl-complete'
                  : '' || upload_data
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Upload Data & Run analysis</label>
              <p>
                Ready to get started? Upload your first dataset and prepare to
                run your first analysis.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  uploadDataIsHidden
                    ? 'tl-button-complete'
                    : '' || upload_data
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a
                  class="button-blue"
                  href="/datacast/datasets"
                  v-on:click="uploadData"
                >
                  Upload Data
                </a>
              </div>
              <div
                class="tl-hidden"
                v-bind:class="
                  uploadDataIsHidden
                    ? 'tl-complete'
                    : '' || upload_data
                      ? 'tl-complete'
                      : ''
                "
              >
                <p
                  v-bind:class="
                    uploadDataIsHidden
                      ? 'tl-completed'
                      : '' || upload_data
                        ? 'tl-completed'
                        : ''
                  "
                >
                  You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6"
            v-bind:class="
              identifyAndSaveIndicatorsIsHidden
                ? 'd-none'
                : '' || idendify_indicators
                  ? 'd-none'
                  : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                identifyAndSaveIndicatorsIsHidden
                  ? 'tl-complete'
                  : '' || idendify_indicators
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Identify and Save Indicators</label>
              <p>
                Make the most of your analysis by identifying 5 leading
                indicators that are the most relevant to your business, and save
                them to your favorites.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  identifyAndSaveIndicatorsIsHidden
                    ? 'tl-button-complete'
                    : '' || idendify_indicators
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a
                  class="button-blue"
                  href="/datacast/trial-list/indicator-faq"
                  target="_blank"
                  v-on:click="identifyAndSaveIndicators"
                >
                  Learn More
                </a>
              </div>
              <div
                class="tl-hidden"
                v-bind:class="
                  identifyAndSaveIndicatorsIsHidden
                    ? 'tl-complete'
                    : '' || idendify_indicators
                      ? 'tl-complete'
                      : ''
                "
              >
                <p
                  v-bind:class="
                    identifyAndSaveIndicatorsIsHidden
                      ? 'tl-completed'
                      : '' || idendify_indicators
                        ? 'tl-completed'
                        : ''
                  "
                >
                  You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6"
            v-bind:class="
              businessCyclePhaseIsHidden
                ? 'd-none'
                : '' || business_cycle
                  ? 'd-none'
                  : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                businessCyclePhaseIsHidden
                  ? 'tl-complete'
                  : '' || business_cycle
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Understand Business Cycle Phase</label>
              <p>
                Identify the current and upcoming Business Cycle Phases for your
                business, and review the relevant Management Objectives™.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  businessCyclePhaseIsHidden
                    ? 'tl-button-complete'
                    : '' || business_cycle
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a class="button-blue" v-on:click="businessCyclePhase">
                  Learn More
                </a>
              </div>
              <div
                class="tl-hidden"
                v-bind:class="
                  businessCyclePhaseIsHidden
                    ? 'tl-complete'
                    : '' || business_cycle
                      ? 'tl-complete'
                      : ''
                "
              >
                <p
                  v-bind:class="
                    businessCyclePhaseIsHidden
                      ? 'tl-completed'
                      : '' || business_cycle
                        ? 'tl-completed'
                        : ''
                  "
                >
                  You completed this task!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-4 screen-help-col"
        v-bind:class="
          (bookWalkthroughIsHidden &&
            reviewMethodologyIsHidden &&
            scheduleTechCheckIsHidden &&
            uploadDataIsHidden &&
            identifyAndSaveIndicatorsIsHidden &&
            businessCyclePhaseIsHidden) ||
          (book_walkthrough &&
            review_methodology &&
            schedule_tech_check &&
            upload_data &&
            idendify_indicators &&
            business_cycle)
            ? 'screen-help-col-false'
            : ''
        "
      >
        <div class="trial-help-box">
          <img src="/images/FAQ.png" alt="Help" class="trial-faq" />
          <p class="trial-help-text">Stuck? Need help?</p>
          <div v-if="dc_tier === 'datacast'" class="datacast-faq">
            <p>
              <a href="https://faq.itreconomics.com/en/datacast-pro">
                Click here
              </a>
              to check out our DataCast Pro™ FAQ.
            </p>
          </div>
          <div v-else class="datacast-faq">
            <p>
              <a href="https://faq.itreconomics.com/en/datacast-essentials">
                Click here
              </a>
              to check out our DataCast Essentials™ FAQ.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div
            class="col-large-6 d-none"
            v-bind:class="
              bookWalkthroughIsHidden
                ? 'd-block'
                : '' || book_walkthrough
                  ? 'd-block'
                  : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                bookWalkthroughIsHidden
                  ? 'tl-complete'
                  : '' || book_walkthrough
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Book a Walkthrough</label>
              <p>
                Schedule a walkthrough with one of our Account Executives to
                explore all the features and capabilities of your subscription.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  bookWalkthroughIsHidden
                    ? 'tl-button-complete'
                    : '' || book_walkthrough
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a class="button-blue" v-on:click="bookWalkthrough">Book Now</a>
              </div>
              <div
                class="tl-hidden"
                v-bind:class="
                  bookWalkthroughIsHidden
                    ? 'tl-complete'
                    : '' || book_walkthrough
                      ? 'tl-complete'
                      : ''
                "
              >
                <p
                  v-bind:class="
                    bookWalkthroughIsHidden
                      ? 'tl-completed'
                      : '' || book_walkthrough
                        ? 'tl-completed'
                        : ''
                  "
                >
                  You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6 d-none"
            v-bind:class="
              reviewMethodologyIsHidden
                ? 'd-block'
                : '' || review_methodology
                  ? 'd-block'
                  : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                reviewMethodologyIsHidden
                  ? 'tl-complete'
                  : '' || review_methodology
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Review Methodology</label>
              <p>
                Learn more about Rates-of-Change, leading indicator analysis,
                and more, by visiting our methodology page.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  reviewMethodologyIsHidden
                    ? 'tl-button-complete'
                    : '' || review_methodology
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a class="button-blue" v-on:click="reviewMethodology">
                  Learn More
                </a>
              </div>
              <div
                class="tl-hidden"
                v-bind:class="
                  reviewMethodologyIsHidden
                    ? 'tl-complete'
                    : '' || review_methodology
                      ? 'tl-complete'
                      : ''
                "
              >
                <p
                  v-bind:class="
                    reviewMethodologyIsHidden
                      ? 'tl-completed'
                      : '' || review_methodology
                        ? 'tl-completed'
                        : ''
                  "
                >
                  You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6 d-none"
            v-bind:class="
              scheduleTechCheckIsHidden
                ? 'd-block'
                : '' || schedule_tech_check
                  ? 'd-block'
                  : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                scheduleTechCheckIsHidden
                  ? 'tl-complete'
                  : '' || schedule_tech_check
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Schedule a Tech Check</label>
              <p>
                Meet with our customer care team to check that everything is
                running smoothly with your subscription.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  scheduleTechCheckIsHidden
                    ? 'tl-button-complete'
                    : '' || schedule_tech_check
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a class="button-blue" v-on:click="scheduleTechCheck">
                  Book Now
                </a>
              </div>
              <div
                class="tl-hidden"
                v-bind:class="
                  scheduleTechCheckIsHidden
                    ? 'tl-complete'
                    : '' || schedule_tech_check
                      ? 'tl-complete'
                      : ''
                "
              >
                <p
                  v-bind:class="
                    scheduleTechCheckIsHidden
                      ? 'tl-completed'
                      : '' || schedule_tech_check
                        ? 'tl-completed'
                        : ''
                  "
                >
                  You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6 d-none"
            v-bind:class="
              uploadDataIsHidden
                ? 'd-block'
                : '' || upload_data
                  ? 'd-block'
                  : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                uploadDataIsHidden
                  ? 'tl-complete'
                  : '' || upload_data
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Upload Data & Run analysis</label>
              <p>
                Ready to get started? Upload your first dataset and prepare to
                run your first analysis.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  uploadDataIsHidden
                    ? 'tl-button-complete'
                    : '' || upload_data
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a
                  class="button-blue"
                  href="/datacast/datasets"
                  v-on:click="uploadData"
                >
                  Upload Data
                </a>
              </div>
              <div
                class="tl-hidden"
                v-bind:class="
                  uploadDataIsHidden
                    ? 'tl-complete'
                    : '' || upload_data
                      ? 'tl-complete'
                      : ''
                "
              >
                <p
                  v-bind:class="
                    uploadDataIsHidden
                      ? 'tl-completed'
                      : '' || upload_data
                        ? 'tl-completed'
                        : ''
                  "
                >
                  You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6 d-none"
            v-bind:class="
              identifyAndSaveIndicatorsIsHidden
                ? 'd-block'
                : '' || idendify_indicators
                  ? 'd-block'
                  : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                identifyAndSaveIndicatorsIsHidden
                  ? 'tl-complete'
                  : '' || idendify_indicators
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Identify and Save Indicators</label>
              <p>
                Make the most of your analysis by identifying 5 leading
                indicators that are the most relevant to your business, and save
                them to your favorites.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  identifyAndSaveIndicatorsIsHidden
                    ? 'tl-button-complete'
                    : '' || idendify_indicators
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a class="button-blue" v-on:click="identifyAndSaveIndicators">
                  Learn More
                </a>
              </div>
              <div
                class="tl-hidden"
                v-bind:class="
                  identifyAndSaveIndicatorsIsHidden
                    ? 'tl-complete'
                    : '' || idendify_indicators
                      ? 'tl-complete'
                      : ''
                "
              >
                <p
                  v-bind:class="
                    identifyAndSaveIndicatorsIsHidden
                      ? 'tl-completed'
                      : '' || idendify_indicators
                        ? 'tl-completed'
                        : ''
                  "
                >
                  You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-large-6 d-none"
            v-bind:class="
              businessCyclePhaseIsHidden
                ? 'd-block'
                : '' || business_cycle
                  ? 'd-block'
                  : ''
            "
          >
            <div
              class="trial-box"
              v-bind:class="
                businessCyclePhaseIsHidden
                  ? 'tl-complete'
                  : '' || business_cycle
                    ? 'tl-complete'
                    : ''
              "
            >
              <label>Understand Business Cycle Phase</label>
              <p>
                Identify the current and upcoming Business Cycle Phases for your
                business, and review the relevant Management Objectives™.
              </p>
              <div
                class="tl-button"
                v-bind:class="
                  businessCyclePhaseIsHidden
                    ? 'tl-button-complete'
                    : '' || business_cycle
                      ? 'tl-button-complete'
                      : ''
                "
              >
                <a class="button-blue" v-on:click="businessCyclePhase">
                  Learn More
                </a>
              </div>
              <div
                class="tl-hidden"
                v-bind:class="
                  businessCyclePhaseIsHidden
                    ? 'tl-complete'
                    : '' || business_cycle
                      ? 'tl-complete'
                      : ''
                "
              >
                <p
                  v-bind:class="
                    businessCyclePhaseIsHidden
                      ? 'tl-completed'
                      : '' || business_cycle
                        ? 'tl-completed'
                        : ''
                  "
                >
                  You completed this task!
                </p>
              </div>
            </div>
          </div>
          <div class="col-large-6 trial-help-mobile">
            <div class="trial-help-box">
              <img src="/images/FAQ.png" alt="Help" class="trial-faq" />
              <p class="trial-help-text">Stuck? Need help?</p>
              <div v-if="dc_tier === 'datacast'" class="datacast-faq">
                <p>
                  <a href="https://faq.itreconomics.com/en/datacast-pro">
                    Click here
                  </a>
                  to check out our DataCast Pro™ FAQ.
                </p>
              </div>
              <div v-else class="datacast-faq">
                <p>
                  <a href="https://faq.itreconomics.com/en/datacast-essentials">
                    Click here
                  </a>
                  to check out our DataCast Essentials™ FAQ.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4 trial-dummy-spacer">
        <div
          class="trial-help-box"
          v-bind:class="
            (bookWalkthroughIsHidden &&
              reviewMethodologyIsHidden &&
              scheduleTechCheckIsHidden &&
              uploadDataIsHidden &&
              identifyAndSaveIndicatorsIsHidden &&
              businessCyclePhaseIsHidden) ||
            (book_walkthrough &&
              review_methodology &&
              schedule_tech_check &&
              upload_data &&
              idendify_indicators &&
              business_cycle)
              ? ''
              : 'invisible'
          "
        >
          <img src="/images/FAQ.png" alt="Help" class="trial-faq" />
          <p class="trial-help-text">Stuck? Need help?</p>
          <div v-if="dc_tier === 'datacast'" class="datacast-faq">
            <p>
              <a href="https://faq.itreconomics.com/en/datacast-pro">
                Click here
              </a>
              to check out our DataCast Pro™ FAQ.
            </p>
          </div>
          <div v-else class="datacast-faq">
            <p>
              <a href="https://faq.itreconomics.com/en/datacast-essentials">
                Click here
              </a>
              to check out our DataCast Essentials™ FAQ.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  export default {
    name: 'TrialListComponent',
    props: { 
      remaining_days: {
        type: Number,
        required: true,
      },
      dc_tier: {
        type: String,
        required: true,
      },
      book_walkthrough: {
        type: Boolean,
        required: true,
      },
      review_methodology: {
        type: Boolean,
        required: true,
      },
      schedule_tech_check: {
        type: Boolean,
        required: true,
      },
      upload_data: {
        type: Boolean,
        required: true,
      },
      idendify_indicators: {
        type: Boolean,
        required: true,
      },
      business_cycle: {
        type: Boolean,
        required: true,
      },
      product_id: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        bookWalkthroughIsHidden: false,
        reviewMethodologyIsHidden: false,
        scheduleTechCheckIsHidden: false,
        uploadDataIsHidden: false,
        identifyAndSaveIndicatorsIsHidden: false,
        businessCyclePhaseIsHidden: false,
        listComplete: false,
      };
    },
    mounted() {
      this.setHelpImageWhenComplete();
    },
    methods: {
      setHelpImageWhenComplete: function () {
        if (
          (this.bookWalkthroughIsHidden &&
            this.reviewMethodologyIsHidden &&
            this.scheduleTechCheckIsHidden &&
            this.uploadDataIsHidden &&
            this.identifyAndSaveIndicatorsIsHidden &&
            this.businessCyclePhaseIsHidden) ||
          (this.book_walkthrough &&
            this.review_methodology &&
            this.schedule_tech_check &&
            this.upload_data &&
            this.idendify_indicators &&
            this.business_cycle)
        ) {
          this.listComplete = true;
        }
      },
      bookWalkthrough: function () {
        var description = 'book_walkthrough';
        var productId = this.product_id;
        this.bookWalkthroughIsHidden = true;

        if (productId == 6) {
          window.open(
            'https://meetings.hubspot.com/lwall/datacast-pro-discussion',
            'popup',
            'width=800,height=600'
          );
        } else {
          window.open(
            'https://meetings.itreconomics.com/meetings/itr/datacast-essentials-free-demo',
            'popup',
            'width=800,height=600'
          );
        }
        axios
          .post('/datacast/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      reviewMethodology: function () {
        window.open(
          'https://itreconomics.com/methodology',
          'width=800,height=600'
        );
        var description = 'review_methodology';
        var productId = this.product_id;
        this.reviewMethodologyIsHidden = true;
        axios
          .post('/datacast/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      scheduleTechCheck: function () {
        var description = 'schedule_tech_check';
        var productId = this.product_id;
        this.scheduleTechCheckIsHidden = true;

        if (productId == 6) {
          window.open(
            'https://meetings.hubspot.com/itranne/datacast-pro-tech-chat',
            'popup',
            'width=800,height=600'
          );
        } else {
          window.open(
            'https://meetings.hubspot.com/itranne/datacast-essentials-tech-chat',
            'popup',
            'width=800,height=600'
          );
        }

        axios
          .post('/datacast/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      uploadData: function () {
        var description = 'upload_data';
        var productId = this.product_id;
        this.uploadDataIsHidden = true;
        axios
          .post('/datacast/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      identifyAndSaveIndicators: function () {
        var description = 'idendify_indicators';
        var productId = this.product_id;
        this.identifyAndSaveIndicatorsIsHidden = true;
        axios
          .post('/datacast/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      businessCyclePhase: function () {
        window.open('/datacast/video/36', 'popup', 'width=800,height=600');
        var description = 'business_cycle';
        var productId = this.product_id;
        this.businessCyclePhaseIsHidden = true;
        axios
          .post('/datacast/trial-list/' + productId + '/' + description)
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
    },
  };
</script>
